import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const modal = document.querySelector('#reservationModal')
    if (modal) {
      modal.addEventListener('show.bs.modal', () => {
        modal.removeAttribute('aria-hidden')
      })

      modal.addEventListener('hidden.bs.modal', () => {
        modal.setAttribute('aria-hidden', 'true')
      })
    }
  }

  async openModal(event) {
    const date = event.currentTarget.dataset.date
    const time = event.currentTarget.dataset.time
    const modal = document.querySelector('#reservationModal')

    // 予約タブの入力欄
    const startTimeInput = modal.querySelector('[data-reservation-form-target="startTime"]')
    const endTimeInput = modal.querySelector('[data-reservation-form-target="endTime"]')

    // ブロックタブの入力欄
    const blockStartTimeInput = modal.querySelector('[data-block-form-target="startTime"]')
    const blockEndTimeInput = modal.querySelector('[data-block-form-target="endTime"]')

    if (date && time) {
      const dateTime = `${date}T${time}`

      // 予約タブの日時を設定
      if (startTimeInput) {
        startTimeInput.value = dateTime
        // 開始時間が設定されたら、change イベントを発火して終了時間を更新
        startTimeInput.dispatchEvent(new Event('change', { bubbles: true }))
      }

      // ブロックタブの日時も設定
      if (blockStartTimeInput) {
        blockStartTimeInput.value = dateTime
        // デフォルトで1時間後を終了時間に設定
        const startDate = new Date(dateTime)
        startDate.setHours(startDate.getHours() + 1)
        const year = startDate.getFullYear()
        const month = String(startDate.getMonth() + 1).padStart(2, '0')
        const day = String(startDate.getDate()).padStart(2, '0')
        const hours = String(startDate.getHours()).padStart(2, '0')
        const minutes = String(startDate.getMinutes()).padStart(2, '0')
        blockEndTimeInput.value = `${year}-${month}-${day}T${hours}:${minutes}`
      }
    }

    // 動的にBootstrapをインポート
    const bootstrap = await import("bootstrap")
    const Modal = bootstrap.Modal

    // インスタンスが既に存在するか確認
    let bootstrapModal = Modal.getInstance(modal)
    if (!bootstrapModal) {
      bootstrapModal = new Modal(modal)
    }
    bootstrapModal.show()
  }
}
